module.exports = __webpack_public_path__ + "img/groupScan.591695fd.png";